export function QuantityValueSummary(value: number, quantity: number) {
  const valueNumber = Number(value);
  const quantityNumber = Number(quantity);
  const valuePerItem = Math.floor((valueNumber / quantityNumber) * 100) / 100;
  const totalValueWithoutLeftOver = valuePerItem * quantityNumber;
  const valueLeftOver = Math.round((valueNumber - totalValueWithoutLeftOver) * 100) / 100;
  return {
    valuePerItem: valuePerItem,
    valueLeftOver: valueLeftOver,
    valueForFirstItem: valuePerItem + valueLeftOver,
    valueForOtherItems: valuePerItem
  };
}
